import { render } from "./WorkbookCard.vue?vue&type=template&id=45451d18"
import script from "./WorkbookCard.vue?vue&type=script&lang=js"
export * from "./WorkbookCard.vue?vue&type=script&lang=js"

import "./WorkbookCard.vue?vue&type=style&index=0&id=45451d18&lang=css"
script.render = render

export default script